import React from 'react';

export const CCTVCamera = ({ size = 120, color = '#0f2a5e' }) => (
  <svg width={size} height={size} viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Camera housing */}
    <rect x="8" y="22" width="72" height="36" rx="6" fill={color} opacity="0.9"/>
    {/* Lens ring */}
    <circle cx="44" cy="40" r="14" fill="none" stroke="white" strokeWidth="3" opacity="0.6"/>
    <circle cx="44" cy="40" r="9" fill="#1e8a4c" opacity="0.8"/>
    <circle cx="44" cy="40" r="4" fill="white" opacity="0.9"/>
    <circle cx="46" cy="38" r="1.5" fill="white"/>
    {/* Viewfinder */}
    <path d="M80 28L104 18V62L80 52" fill={color} opacity="0.8"/>
    <path d="M80 30L100 21V59L80 50" fill="white" opacity="0.15"/>
    {/* IR LEDs */}
    <circle cx="20" cy="30" r="3" fill="#f97316" opacity="0.7"/>
    <circle cx="20" cy="50" r="3" fill="#f97316" opacity="0.7"/>
    <circle cx="70" cy="30" r="3" fill="#f97316" opacity="0.7"/>
    <circle cx="70" cy="50" r="3" fill="#f97316" opacity="0.7"/>
    {/* Mount */}
    <rect x="35" y="58" width="18" height="8" rx="2" fill={color} opacity="0.6"/>
    <rect x="30" y="66" width="28" height="6" rx="2" fill={color} opacity="0.5"/>
    {/* Status LED */}
    <circle cx="15" cy="40" r="3" fill="#22c55e"/>
    <circle cx="15" cy="40" r="5" fill="#22c55e" opacity="0.2"/>
  </svg>
);

export const DomeCCTV = ({ size = 100, color = '#0f2a5e' }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Ceiling mount */}
    <rect x="35" y="5" width="30" height="8" rx="3" fill={color} opacity="0.5"/>
    <rect x="45" y="13" width="10" height="10" rx="2" fill={color} opacity="0.6"/>
    {/* Dome housing */}
    <ellipse cx="50" cy="62" rx="38" ry="12" fill={color} opacity="0.2"/>
    <path d="M12 58C12 38.1 29.9 22 50 22C70.1 22 88 38.1 88 58" fill={color} opacity="0.9"/>
    <path d="M16 58C16 40.3 31.6 26 50 26C68.4 26 84 40.3 84 58" fill="white" opacity="0.08"/>
    {/* Lens */}
    <circle cx="50" cy="50" r="12" fill="#1e8a4c" opacity="0.9"/>
    <circle cx="50" cy="50" r="7" fill={color}/>
    <circle cx="50" cy="50" r="3" fill="white" opacity="0.8"/>
    <circle cx="52" cy="48" r="1.5" fill="white"/>
    {/* Status */}
    <circle cx="32" cy="55" r="3" fill="#22c55e"/>
  </svg>
);

export const PTZCamera = ({ size = 120, color = '#0f2a5e' }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Pole */}
    <rect x="56" y="90" width="8" height="30" rx="2" fill={color} opacity="0.4"/>
    {/* Base */}
    <ellipse cx="60" cy="120" rx="18" ry="5" fill={color} opacity="0.3"/>
    {/* Pan head */}
    <ellipse cx="60" cy="90" rx="22" ry="8" fill={color} opacity="0.6"/>
    {/* Camera body */}
    <rect x="32" y="55" width="56" height="35" rx="8" fill={color} opacity="0.9"/>
    {/* Lens tube */}
    <ellipse cx="60" cy="55" rx="14" ry="10" fill={color}/>
    <circle cx="60" cy="55" r="8" fill="#1e8a4c" opacity="0.9"/>
    <circle cx="60" cy="55" r="4" fill="white" opacity="0.8"/>
    <circle cx="62" cy="53" r="1.5" fill="white"/>
    {/* Side detail */}
    <rect x="34" y="63" width="8" height="3" rx="1" fill="white" opacity="0.2"/>
    <rect x="34" y="69" width="6" height="3" rx="1" fill="white" opacity="0.2"/>
    {/* Status LED */}
    <circle cx="82" cy="62" r="3" fill="#22c55e"/>
    {/* IR ring */}
    <circle cx="60" cy="55" r="14" fill="none" stroke="white" strokeWidth="1.5" strokeDasharray="3 2" opacity="0.3"/>
  </svg>
);

export const DVRUnit = ({ size = 140, color = '#0f2a5e' }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 140 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Main body */}
    <rect x="4" y="15" width="132" height="60" rx="6" fill={color} opacity="0.9"/>
    {/* Front panel */}
    <rect x="8" y="19" width="124" height="52" rx="4" fill={color}/>
    {/* Drive bays */}
    {[0,1,2,3].map(i => (
      <rect key={i} x={14 + i*18} y="26" width="14" height="20" rx="2" fill="white" opacity="0.08"/>
    ))}
    {/* Activity LEDs */}
    {[0,1,2,3].map(i => (
      <circle key={i} cx={21 + i*18} cy="52" r="3" fill={i < 3 ? "#22c55e" : "#f97316"} opacity="0.9"/>
    ))}
    {/* Display */}
    <rect x="92" y="26" width="36" height="24" rx="3" fill="#0a1628"/>
    <rect x="95" y="29" width="30" height="4" rx="1" fill="#22c55e" opacity="0.7"/>
    <rect x="95" y="35" width="22" height="3" rx="1" fill="white" opacity="0.2"/>
    <rect x="95" y="40" width="25" height="3" rx="1" fill="white" opacity="0.15"/>
    {/* Buttons */}
    <circle cx="96" cy="57" r="4" fill={color} opacity="0.5" stroke="white" strokeWidth="1" strokeOpacity="0.2"/>
    <circle cx="108" cy="57" r="4" fill={color} opacity="0.5" stroke="white" strokeWidth="1" strokeOpacity="0.2"/>
    <circle cx="120" cy="57" r="4" fill="#1e8a4c" opacity="0.8"/>
    {/* Power LED */}
    <circle cx="14" cy="57" r="4" fill="#22c55e"/>
    <circle cx="14" cy="57" r="7" fill="#22c55e" opacity="0.15"/>
    {/* Vents */}
    {[0,1,2,3,4].map(i => (
      <rect key={i} x={130} y={22 + i*8} width="2" height="5" rx="1" fill="white" opacity="0.1"/>
    ))}
  </svg>
);

export const ShieldIcon = ({ size = 60, color = '#0f2a5e' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 5L8 15V30C8 42.4 17.6 54 30 57.5C42.4 54 52 42.4 52 30V15L30 5Z" fill={color} opacity="0.12"/>
    <path d="M30 5L8 15V30C8 42.4 17.6 54 30 57.5C42.4 54 52 42.4 52 30V15L30 5Z" fill="none" stroke={color} strokeWidth="2.5"/>
    <polyline points="20,30 27,37 40,22" stroke="#1e8a4c" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const InstallationIllustration = ({ width = 400, height = 280 }) => (
  <svg width={width} height={height} viewBox="0 0 400 280" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Building wall */}
    <rect x="0" y="0" width="400" height="280" fill="#f0f4fb"/>
    {/* Wall texture */}
    <rect x="20" y="20" width="360" height="240" rx="4" fill="white" opacity="0.6" stroke="#d6dff0" strokeWidth="1.5"/>
    {/* Corner mount bracket */}
    <rect x="50" y="35" width="6" height="40" rx="2" fill="#0f2a5e" opacity="0.6"/>
    <rect x="50" y="35" width="40" height="6" rx="2" fill="#0f2a5e" opacity="0.6"/>
    {/* CCTV on bracket */}
    <rect x="78" y="32" width="44" height="22" rx="4" fill="#0f2a5e"/>
    <circle cx="100" cy="43" r="8" fill="#1a3a7a"/>
    <circle cx="100" cy="43" r="5" fill="#1e8a4c"/>
    <circle cx="100" cy="43" r="2.5" fill="white"/>
    <path d="M122 36L138 30V56L122 50" fill="#0f2a5e" opacity="0.8"/>
    <circle cx="84" cy="43" r="2" fill="#22c55e"/>
    {/* Field of view cone */}
    <path d="M138 43L320 10V76L138 43Z" fill="#1e8a4c" opacity="0.06"/>
    <path d="M138 43L320 10" stroke="#1e8a4c" strokeWidth="1" strokeDasharray="6 4" opacity="0.3"/>
    <path d="M138 43L320 76" stroke="#1e8a4c" strokeWidth="1" strokeDasharray="6 4" opacity="0.3"/>
    {/* Technician silhouette */}
    <circle cx="300" cy="130" r="14" fill="#0f2a5e" opacity="0.15"/>
    <rect x="288" y="144" width="24" height="40" rx="4" fill="#0f2a5e" opacity="0.15"/>
    <rect x="282" y="152" width="12" height="26" rx="3" fill="#0f2a5e" opacity="0.12"/>
    <rect x="306" y="150" width="12" height="28" rx="3" fill="#0f2a5e" opacity="0.12"/>
    {/* Ladder */}
    <rect x="330" y="100" width="4" height="140" rx="1" fill="#0f2a5e" opacity="0.2"/>
    <rect x="355" y="100" width="4" height="140" rx="1" fill="#0f2a5e" opacity="0.2"/>
    {[0,1,2,3,4,5,6].map(i => (
      <rect key={i} x="330" y={110 + i*18} width="29" height="3" rx="1" fill="#0f2a5e" opacity="0.15"/>
    ))}
    {/* Cables */}
    <path d="M56 75 Q56 200 56 240" stroke="#0f2a5e" strokeWidth="2" strokeDasharray="4 3" opacity="0.3"/>
    {/* Network icon */}
    <rect x="140" y="180" width="60" height="40" rx="4" fill="#0f2a5e" opacity="0.08" stroke="#d6dff0"/>
    <circle cx="170" cy="200" r="8" fill="none" stroke="#1e8a4c" strokeWidth="1.5" opacity="0.5"/>
    <line x1="170" y1="192" x2="170" y2="208" stroke="#1e8a4c" strokeWidth="1.5" opacity="0.5"/>
    <line x1="162" y1="200" x2="178" y2="200" stroke="#1e8a4c" strokeWidth="1.5" opacity="0.5"/>
    {/* Label */}
    <rect x="120" y="255" width="160" height="18" rx="4" fill="#0f2a5e" opacity="0.06"/>
    <text x="200" y="268" textAnchor="middle" fill="#0f2a5e" fontSize="10" fontFamily="sans-serif" opacity="0.5">Professional Installation</text>
  </svg>
);
